import { useCallback, useContext, useEffect, useId, useRef } from 'react';
import { getMenuItemState } from '../utils/getMenuItemState';
import { MenuContext } from '../context/MenuContext';
const useMenuItem = ({
  visuallyHidden,
  id
}) => {
  const {
    setMenuItem,
    hideMenuItem,
    menuItemsState,
    onMenuItemKeyDown
  } = useContext(MenuContext);
  const menuItemRef = useRef(undefined);
  const generatedId = useId();
  const menuItemId = useRef(id || generatedId);
  const addedMenuItem = useRef(false);
  const {
    tabIndex,
    isFocused
  } = getMenuItemState(menuItemId.current, menuItemsState);
  const setRef = useCallback(ref => {
    if (ref && !addedMenuItem.current) {
      menuItemRef.current = ref;
      setMenuItem({
        id: menuItemId.current,
        visuallyHidden
      });
      addedMenuItem.current = true;
    }
  }, [setMenuItem, visuallyHidden]);
  useEffect(() => {
    if (menuItemRef.current && isFocused) {
      menuItemRef.current.focus();
    }
  }, [isFocused]);
  useEffect(() => {
    const menuItemToHide = menuItemId.current;
    return () => {
      hideMenuItem({
        id: menuItemToHide
      });
    };
  }, [hideMenuItem]);
  return {
    tabIndex,
    setRef,
    onMenuItemKeyDown,
    menuItemId: menuItemId.current,
    menuItemRef
  };
};
export default useMenuItem;